import React from 'react'
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import Avatar from '@mui/material/Avatar';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import { useNavigate } from 'react-router-dom'
import { useGetUserInfoQuery } from './services/api';
import { useDispatch } from 'react-redux';
import { logout } from './features/auth/authSlice';

const UserMenu = () => {
  const dispatch = useDispatch()

  const { data: user } = useGetUserInfoQuery()
  const navigate = useNavigate()

  const [anchorElUser, setAnchorElUser] = React.useState<null | HTMLElement>(null);
  const handleOpenUserMenu = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorElUser(event.currentTarget);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };

  return (
    <Box sx={{ flexGrow: 0 }}>
      <Tooltip title="Open settings">
        <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
          <Avatar alt={user?.username} src="/static/images/avatar/2.jpg" />
        </IconButton>
      </Tooltip>
      <Menu
        sx={{ mt: '45px' }}
        id="menu-appbar"
        anchorEl={anchorElUser}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        keepMounted
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        open={Boolean(anchorElUser)}
        onClose={handleCloseUserMenu}
      >
        {user?.role === 'admin' && <>
          <MenuItem onClick={() => {
            handleCloseUserMenu();
            navigate(`/admin`);
          }}>
            <Typography textAlign="center">Admin</Typography>
          </MenuItem>
        </>}
        <MenuItem onClick={() => {
          handleCloseUserMenu();
          navigate(`/dashboard`);
        }}>
          <Typography textAlign="center">Dashboard</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          handleCloseUserMenu();
          navigate(`/profile`);
        }}>
          <Typography textAlign="center">Settings</Typography>
        </MenuItem>
        <MenuItem onClick={() => {
          handleCloseUserMenu();
          dispatch(
            logout()
          )
          window.location.href = '/login'
        }}>
          <Typography textAlign="center">Logout</Typography>
        </MenuItem>
      </Menu>
    </Box>
  )
}

export default UserMenu;